var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpload18Hover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_upload_18_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_upload_18_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_black_24dp-(1)-copy-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12 L10.5,12 C10.9125,12 11.25,11.6625 11.25,11.25 L11.25,7.5 L12.4425,7.5 C13.11,7.5 13.4475,6.69 12.975,6.2175 L9.5325,2.775 C9.24,2.4825 8.7675,2.4825 8.475,2.775 L5.0325,6.2175 C4.56,6.69 4.89,7.5 5.5575,7.5 L6.75,7.5 L6.75,11.25 C6.75,11.6625 7.0875,12 7.5,12 Z M4.5,13.5 L13.5,13.5 C13.9125,13.5 14.25,13.8375 14.25,14.25 C14.25,14.6625 13.9125,15 13.5,15 L4.5,15 C4.0875,15 3.75,14.6625 3.75,14.25 C3.75,13.8375 4.0875,13.5 4.5,13.5 Z",
    id: "Shape",
    fill: "#5697B7",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload18Hover);
export default __webpack_public_path__ + "static/media/icon_upload_18_hover.fa8cfe2dbb70593baba148553331ce68.svg";
export { ForwardRef as ReactComponent };